import {getRouteApi} from "@tanstack/react-router";

export const servicesRouteApi = getRouteApi("/_app/engineering/services/");
